import React, { useState } from 'react';
import type { CreateRoomModalProps } from './CreateRoomModal';
import { importWithRetry } from '../../utils/staleBundle';

/**
 * CORE-1802 — окно создания комнаты нужно четырём ленивым экранам (дашборд,
 * практики, практика, комнаты). Статический импорт делал его общим для их
 * чанков, и Expo уносил ~140 КБ в `__common`, который грузится на каждой
 * странице. Здесь окно скачивается при первом открытии; после этого остаётся
 * смонтированным, чтобы закрытие шло своей анимацией.
 */
const CreateRoomModalImpl = React.lazy(() =>
  importWithRetry(() => import('./CreateRoomModal')).then((m) => ({ default: m.CreateRoomModal })),
);

export const CreateRoomModal: React.FC<CreateRoomModalProps> = (props) => {
  const [opened, setOpened] = useState(props.visible);
  if (props.visible && !opened) setOpened(true);
  if (!opened) return null;
  return (
    <React.Suspense fallback={null}>
      <CreateRoomModalImpl {...props} />
    </React.Suspense>
  );
};
